﻿window.cObjetPrestationMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "Prestation"; }
    this.mGetAttributBase = function () { return "la " }
    this.mGetNewLib = function () { return "Nouvelle prestation"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data == 'undefined' && objet.data == null) { txt = "Prestation" }
        else {
            txt = objet.data.nom
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-martini-glass-citrus'></i>");
    }

    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        $("<div style='overflow:hidden;text-overflow:ellipsis;width:100%;padding:0 3px;'>" + dataTemplate.nom + "</div>").appendTo(contentElement)
    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus) {
        $("<div style='' title='Créé le " + dataPlus.dcr.toFrenchDateTime() + "'><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</div>").appendTo(contentElement)
        $("<div style='' title='Modifié le " + dataPlus.dmo.toFrenchDateTime() + "'><i class='fas fa-pen dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dmo.toDateIlya(true) + "</div>").appendTo(contentElement)
    }

}